<template>
  <div class="materual-wrapper">
    <el-tabs v-model="activeInd">
      <el-tab-pane label="上传图片" name="1"> </el-tab-pane>
    </el-tabs>
    <div v-show="activeInd == 1" class="iu-wrapper">
      <img-upload
        @OnImgChange="OnUploadImgChange"
        :max-length="maxLength"
        ref="imgUploads"
      ></img-upload>
      <div class="footer">
        <div class="switch"></div>
        <div class="type">
          <div v-if="isSyncUpload">
            <b style="font-size: 14px" class="m-r-10">分组</b>
            <el-select
              v-model="category"
              placeholder="请选择"
              size="small"
              class="width-100"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
                v-if="item.id >= 0"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="btn">
          <el-button size="small" type="danger" @click="onSubmit()" v-if="!upNum(uploadImgList)"
            >确认同步</el-button>
          <el-button size="small" type="danger" icon="el-icon-loading" disabled v-if="upNum(uploadImgList)"
            >上传中{{upNum(uploadImgList)}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ImgUpload from "../img-upload";
import ImgWarehouse from "../img-warehouse";
import MaterialDepositoryService from "@/service/MaterialDepository.service.js";
export default {
  components: {
    ImgUpload,
    ImgWarehouse,
  },
  props: {
    maxLength: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      activeInd: "1", // tab下标
      typeList: [],
      category: 0,
      isSyncUpload: true, // 是否同步上传到素材库
      uploadImgList: [], // 选中图片 item => ({url: '', width: '', height: '', name: ''})
      selImgList: [], // 选中图片 item => ({url: '', width: '', height: '', name: ''})
    };
  },
  methods: {
    // 点击提交
    onSubmit() {
      const data = this.uploadImgList.map((item) => {
        item.response.title = item.name;
        return item.response;
      });
      if (this.isSyncUpload && data.length > 0) {
        MaterialDepositoryService.add({ data, category: this.category }).then((res) => {
          this.$notify({
            title: "成功",
            message: `已同步上传到素材库`,
            type: "success",
          });
          this.$refs.imgUploads.clearList();
          this.$emit("onImgsSubmit", this.uploadImgList);
        });
      }
    },
    upNum (list) {
      const total = list.length
      let success_num = 0
      list.forEach(item => {
        if (item.status == 'success') {
          success_num++
        }
      });
      if (total > success_num) {
        return `${success_num}/${total}`
      } else {
        return ''
      }
    },
    OnUploadImgChange(callbackData) {
      this.uploadImgList = callbackData;
    },
    OnSelImgChange(callbackData) {
      this.selImgList = callbackData;
    },
    onSelSubmit() {
      this.$emit("onImgsSubmit", this.selImgList);
      this.$refs.imgWarehouse.clearList();
    },
  },
  mounted() {
    MaterialDepositoryService.getTypeList({ size: 1000 }).then((res) => {
      this.typeList = res.results;
    });
  },
};
</script>
<style lang="scss" scoped>
.materual-wrapper {
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  .iu-wrapper {
    width: calc(100% - 30px);
    position: absolute;
    top: 20px;
    bottom: 0;
    overflow: hidden;
    left: 15px;
  }
  .footer {
    width: 100%;
    height: 50px;
    position: absolute;
    bottom: 0;
    border-top: solid 1px #ccc;
    display: flex;
    align-items: center;
    background: #fff;
    .type {
      flex: 1;
      text-align: left;
      margin: 0 10px;
    }
  }
}
</style>